export class SearchManager {
    constructor(searchConfig) {
        this.searchConfig = searchConfig;
        this.searchTypes = searchConfig.searchTypes;
        this.searchText = searchConfig.searchText;
    }
    getBySearchType(n) {
        return this.searchTypes[n]
    }
    getSearchFields(n){
        const a = this.getBySearchType(n);
        return [a.joins.field]
    }
    getSearchFieldMap(n){
        const a = this.getBySearchType(n);
        return [a.joins]
    }
    getAPI(n){
        const a = this.getBySearchType(n);
        return a.api
    }
    getSearchTemplate(n){
        const a = this.getBySearchType(n);
        return a.searchTemplate
    }
    getOutFields(n){
        const a = this.getBySearchType(n);
        return a.retrieves.map(el => el.field)
    }
    getDefinitionExpression(n){
        const outFields = this.getOutFields(n);
        return outFields.join(" IS NOT NULL AND ") + " IS NOT NULL"
    }
    getLabelForField(n, field){
        const a = this.getBySearchType(n);
        return a.retrieves.filter(el => el.field === field)[0].label
    }
    getPnumField(n){
        const a = this.getBySearchType(n);
        return a.link.fromColumn
    }
    getLinkToMapping(n){
        const a = this.getBySearchType(n);
        return a.link.linkTo
    }
}